import {scenariosData} from '../data/scenarios-data';

const getSchoolStats = (schoolData, games) => {
	let studentCount = 0;
	let playthroughCount = 0;

	/* Get stats from deleted games */
	if (schoolData && schoolData.gameStats && schoolData.gameStats.length > 0) {
		schoolData.gameStats.forEach((gameStat) => {
			if (!gameStat.resetTime) { // Ignore games before a reset action
				playthroughCount += 1;
				if (gameStat.players && gameStat.players > 0) {
					studentCount += gameStat.players;
				}
			}
			
		});
	}

	/* Get stats from existing games */
	if (games && games.length > 0) {
		games.forEach((game) => {
			const scenarioData = game.scenarioId ? scenariosData[game.scenarioId] : scenariosData['game1'];
			const gameDurationMinutes = scenarioData.gameDurationMinutes;
			const startTime = (game.startTime ? game.startTime : null); // miliseconds
			const currentTime = Date.now(); // miliseconds
			const endTime = startTime + (gameDurationMinutes * 60000);
			const isDone = (
				(startTime && currentTime > endTime) ||
				game.status !== 'ready'
			);
			const isReset = Boolean(game.resetTime);
			if (isDone && !isReset)  {
				playthroughCount += 1;
				if (game.studentCount) {
					studentCount += parseInt(game.studentCount);
				}
			}
		});
	}

	return {playthroughCount, studentCount};
};


export {
	getSchoolStats
};